var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from "react";
import { locationPointer } from "../../../images/icon";
import './zipcode.scss';
import { updateUserIdentityData } from "./helper";
import pubsub from "@viewlift/pubsub";
import { dynamicConfig } from "../DynamicRoutes";
import { useNavigate } from "react-router-dom";
import Spinner from '../HomeLoadingScreen/Spinner';
import { getStorageItem, setStorageItem } from "../../helpers/storageManager";
// import { LocationCoords } from "./Modals";
var Zipcode = function (_a) {
    var _b;
    var module = _a.module, isNoPlans = _a.isNoPlans;
    var _c = __read(useState(null), 2), locationData = _c[0], setLocationData = _c[1];
    var _d = __read(useState(true), 2), loading = _d[0], setLoading = _d[1];
    var metadataMap = (_b = module === null || module === void 0 ? void 0 : module.module) === null || _b === void 0 ? void 0 : _b.metadataMap;
    var navigate = useNavigate();
    var recTimer = useRef(null);
    useEffect(function () {
        var flowWrapperEle = document.querySelector('.locate-design-wrapper');
        if (flowWrapperEle) {
            flowWrapperEle.getElementsByClassName('geo-locate-wrapper')[0]['style'].padding = '0px';
            flowWrapperEle.getElementsByClassName('right-section')[0].classList.add('zipcode-right-section');
        }
        return function () {
            var flowWrapperEle = document.querySelector('.locate-design-wrapper');
            if (flowWrapperEle) {
                flowWrapperEle.getElementsByClassName('geo-locate-wrapper')[0]['style'].padding = '16px';
                flowWrapperEle.getElementsByClassName('right-section')[0].classList.remove('zipcode-right-section');
            }
        };
    }, []);
    var fetchCoords = function () {
        var locationInfo = localStorage.getItem('locationCoords');
        if (locationInfo)
            setLocationData(JSON.parse(locationInfo));
        return locationInfo;
    };
    var handleLocationCoords = function () {
        if (!loading)
            setLoading(true);
        var locationInfo = fetchCoords();
        if (!locationInfo) {
            clearTimeout(recTimer.current);
            recTimer.current = setTimeout(function () {
                handleLocationCoords();
            }, 500);
        }
        else {
            setLoading(false);
            return;
        }
    };
    useEffect(function () {
        handleLocationCoords();
    }, []);
    var handleSetHomeLocation = function () { return __awaiter(void 0, void 0, void 0, function () {
        var hbaObj, AuthenticationStore;
        return __generator(this, function (_a) {
            setLoading(true);
            hbaObj = locationData.byCoordinates ? { hba: { enabled: true, latitude: locationData === null || locationData === void 0 ? void 0 : locationData.latitude, longitude: locationData === null || locationData === void 0 ? void 0 : locationData.longitude } } : { hba: { enabled: true } };
            AuthenticationStore = getStorageItem('AuthenticationStore');
            {
                locationData && updateUserIdentityData(hbaObj).then(function (res) {
                    var hba = res.data.hba;
                    var user = AuthenticationStore === null || AuthenticationStore === void 0 ? void 0 : AuthenticationStore.user;
                    var updatedUser = __assign(__assign({}, user), { hbaMetadata: hba });
                    setStorageItem('AuthenticationStore', __assign(__assign({}, AuthenticationStore), { user: updatedUser }));
                    if (isNoPlans) {
                        pubsub.publish('apploading', false);
                        setLoading(false);
                        pubsub.publish("reRender", true);
                        window.location.reload();
                    }
                    else {
                        pubsub.publish('apploading', true);
                    }
                    handleNextRoute(false);
                }).catch(function (e) {
                    setLoading(false);
                });
            }
            pubsub.publish("showHbaFlow", false);
            return [2 /*return*/];
        });
    }); };
    var handleNextRoute = function (isSkipped) { return __awaiter(void 0, void 0, void 0, function () {
        var currentQueryParams, needToSetPlatformLocation, routeState, currentRoute, hbaObj, AuthenticationStore_1, nextRoute;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    currentQueryParams = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) || "";
                    needToSetPlatformLocation = sessionStorage.getItem('needToSetPlatformLocation') === 'true';
                    setLoading(true);
                    routeState = getStorageItem("routeState");
                    currentRoute = (_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.pathname;
                    hbaObj = { hba: { enabled: false } };
                    if (!isSkipped) return [3 /*break*/, 2];
                    AuthenticationStore_1 = getStorageItem('AuthenticationStore');
                    return [4 /*yield*/, updateUserIdentityData(hbaObj).then(function (res) {
                            var hba = res.data.hba;
                            var user = AuthenticationStore_1 === null || AuthenticationStore_1 === void 0 ? void 0 : AuthenticationStore_1.user;
                            var updatedUser = __assign(__assign({}, user), { hbaMetadata: hba });
                            setStorageItem('AuthenticationStore', __assign(__assign({}, AuthenticationStore_1), { user: updatedUser }));
                            pubsub.publish('apploading', true);
                            if (isNoPlans) {
                                pubsub.publish('apploading', false);
                                setLoading(false);
                                pubsub.publish("reRender", true);
                                window.location.reload();
                            }
                        }).catch(function (e) {
                            setLoading(false);
                        })];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2: return [4 /*yield*/, dynamicConfig(routeState, location === null || location === void 0 ? void 0 : location.pathname, isSkipped, false, currentRoute)];
                case 3:
                    nextRoute = _c.sent();
                    if (needToSetPlatformLocation) {
                        pubsub.publish('apploading', false);
                        setLoading(false);
                        window.location.replace("/thankyou");
                        sessionStorage.removeItem('needToSetPlatformLocation');
                        return [2 /*return*/];
                    }
                    if (!isNoPlans) {
                        navigate(nextRoute);
                    }
                    pubsub.publish("showHbaFlow", false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null, (loading || !locationData) ? React.createElement(Spinner, null) :
        React.createElement("div", { className: "zipcode-wrapper" },
            React.createElement("div", { className: "zipcode-info" },
                locationPointer(),
                React.createElement("p", { className: "title" }, (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.zipCodeText) || 'Zip Code:'),
                React.createElement("p", { className: "num" }, locationData === null || locationData === void 0 ? void 0 : locationData.postalCode)),
            React.createElement("div", { className: "zipcode-actions" },
                React.createElement("h4", { className: "title" }, (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.setHomeLocationText) || 'Set your home location'),
                React.createElement("p", { className: "description" }, (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.setHomeLocationDescText) || 'You can always change your home location in settings later. Not your zip code? Continue and verify your location in settings later.'),
                React.createElement("div", { className: "action-btn" },
                    React.createElement("button", { "aria-label": "Set as Home Location", className: "btn1", onClick: handleSetHomeLocation }, (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.setHomeLocationBtn) || 'Set as Home Location'),
                    React.createElement("button", { "aria-label": "I'll do it later", className: "btn2", onClick: function () { return handleNextRoute(true); } }, (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.cancelSetLocationText) || "I'll do it later"))))));
};
export default Zipcode;
